import { render, staticRenderFns } from "./packinglist.vue?vue&type=template&id=4c2056d6&scoped=true"
import script from "./packinglist.vue?vue&type=script&lang=js"
export * from "./packinglist.vue?vue&type=script&lang=js"
import style0 from "./packinglist.vue?vue&type=style&index=0&id=4c2056d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2056d6",
  null
  
)

export default component.exports